<template>

    <div>
        <div class="container is-fluid">
            <div class="field">
                <label class="label">Choose Date Range For Report Weekly</label>
                    <div class="control has-icons-left">

                        <datepicker :monday-first="true" input-class="input-class" @opened="openDateCalendar" @closed="GetWeeklyRanged" v-model="selectedDayOrigin" :format="customFormatter" :highlighted="highlighted"></datepicker>

                    </div>
            </div>

            <div style="justify-content: right;">
                <div class="column has-text-right">
                    <font-awesome-icon style="cursor: pointer" class="is-size-5 is-warning" icon="info" @click="infoModal=true"/>
                    </div>
                </div>

            <div v-if="AdvancedSearchBarView" style="padding-bottom: 4px;">
                <button class="advanced-searh-button button is-small is-light"
                        :class="{'is-info':advancedSearchTLC , 'is-danger' : !advancedSearchTLC}"
                        @click="advancedSearchTLC = true, advancedSearchUID = false">TLC Advanced Search
                </button>
<!--                advancedSearchTLC =! advancedSearchTLC,-->
                <button class="advanced-searh-button button is-small is-light"
                        :class="{'is-info':advancedSearchUID , 'is-danger' : !advancedSearchUID}"
                        @click="advancedSearchUID = true, advancedSearchTLC = false">UID Advanced Search
                </button>
<!--                advancedSearchUID =! advancedSearchUID,-->
            </div>

            <div v-if="AdvancedSearchBarView" class="search-menu columns">

                <div v-if="!advancedSearchUID && advancedSearchTLC" class="normal-search column is-9">

                    <div class="level">

                        <div class="level-left">

                            <div class="level-item">
                                <div class="field">
                                    <div class="control">
                                        <input class="input" v-model="advancedSearchFormTLC.tlc" placeholder="TLC">
                                    </div>
                                </div>
                            </div>

                            <div class="level-item">
                                <div class="field">
                                    <div class="select is-info is-normal">
                                        <select class=""  v-model ="advancedSearchFormTLC.pc">
                                            <option value="">Select PC</option>
                                            <option v-for="(ouItem,index) in ProcessCategoryStatArray" :key="index" :value="ouItem">
                                                {{ouItem}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="level-item">
                                <div class="field">
                                    <div class="select is-info is-normal">
                                        <select class=""  v-model ="advancedSearchFormTLC.ct">
                                            <option value="">Select CT</option>
                                            <option v-for="(ouItem,index) in CTStatArray" :key="index" :value="ouItem">
                                                {{ouItem}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="level-item">
                                <div class="field">
                                    <div class="select is-info is-normal">
                                        <select class=""  v-model ="advancedSearchFormTLC.sv">
                                            <option value="">Select SV</option>
                                            <option v-for="(ouItem,index) in SVStatArray" :key="index" :value="ouItem">
                                                {{ouItem}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="level-item">
                                <div class="field">
                                    <div class="control">
                                        <input class="input" v-model="advancedSearchFormTLC.fn" placeholder="FN">
                                    </div>
                                </div>
                            </div>

                            <div class="level-item">
                                <div class="field">
                                    <div class="control">
                                        <input class="input" v-model="advancedSearchFormTLC.txt" placeholder="Message">
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="level-right">
                            <div class="level-item">
                                <div class="control">
                                    <a class="button  is-success is-fullwidth" :disabled="isLoading"
                                       @click="TryAdvancedSearchTLC">
                                        <span class="icon is-small">
                                                <font-awesome-icon :icon="isLoading ? 'sync-alt' : 'search'" :spin = "isLoading"/>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div class="level-right">
                            <div class="level-item">
                                <div class="control">
                                    <a class="button  is-success is-fullwidth" :disabled="isLoading"
                                       @click="GetWeeklyRanged">
                                        <span class="icon is-small">
                                                <font-awesome-icon :icon="isloading ? 'sync-alt' : 'sync-alt'" :spin = "isloading"/>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div v-if="advancedSearchUID && !advancedSearchTLC" class="normal-search column is-9">

                    <div class="level">
                        <div class="level-left">
                            <div class="level-item">
                                <div class="field">
                                    <div class="control">
                                        <input class="input" v-model="advancedSearchFormTLC.uid" placeholder="UID">
                                    </div>
                                </div>
                            </div>

                            <div class="level-item">
                                <div class="field">
                                    <div class="select is-info is-normal">
                                        <select class=""  v-model ="advancedSearchFormTLC.pc">
                                            <option value="">Select PC</option>
                                            <option v-for="(ouItem,index) in ProcessCategoryStatArray" :key="index" :value="ouItem">
                                                {{ouItem}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="level-item">
                                <div class="field">
                                    <div class="select is-info is-normal">
                                        <select class=""  v-model ="advancedSearchFormTLC.ct">
                                            <option value="">Select CT</option>
                                            <option v-for="(ouItem,index) in CTStatArray" :key="index" :value="ouItem">
                                                {{ouItem}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="level-item">
                                <div class="field">
                                    <div class="select is-info is-normal">
                                        <select class=""  v-model ="advancedSearchFormTLC.sv">
                                            <option value="">Select SV</option>
                                            <option v-for="(ouItem,index) in SVStatArray" :key="index" :value="ouItem">
                                                {{ouItem}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="level-item">
                                <div class="field">
                                    <div class="control">
                                        <input class="input" v-model="advancedSearchFormTLC.fn" placeholder="FN">
                                    </div>
                                </div>
                            </div>

                            <div class="level-item">
                                <div class="field">
                                    <div class="control">
                                        <input class="input" v-model="advancedSearchFormTLC.txt" placeholder="Message">
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="level-right">
                            <div class="level-item">
                                <div class="control">
                                    <a class="button  is-success is-fullwidth" :disabled="isLoading"
                                       @click="TryAdvancedSearchTLC">
                                        <span class="icon is-small">
                                                <font-awesome-icon :icon="isLoading ? 'sync-alt' : 'search'" :spin = "isLoading"/>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div class="level-right">
                            <div class="level-item">
                                <div class="control">
                                    <a class="button  is-success is-fullwidth" :disabled="isLoading"
                                       @click="GetWeeklyRanged">
                                        <span class="icon is-small">
                                                <font-awesome-icon :icon="isLoading ? 'sync-alt' : 'sync-alt'" :spin="isLoading"/>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
            <div v-if="isloading">
                <loading-button/>
            </div>
                <div class="user-table">

                <table class="table is-striped is-fullwidth is-bordered animate__animated animate__slideInUp animate__faster fontsizesmall">
                    <thead>
                    <tr>
                        <th>ID</th>
                        <th>TLC</th>
                        <th title="">UID</th>
                        <th>SH</th>
                        <th>LT</th>
                        <th>PC</th>
                        <th>CT</th>
                        <th>SV</th>
                        <th>FN</th>
                        <th>Message</th>
                    </tr>
                    </thead>

                    <tbody v-if="paginate2 && paginate2.length>0">
<!--                    <tr v-for="log in this.OccSideLogList" :key="log.id">-->
                    <tr v-for="log in paginate2" :key="log.id">
                        <td>{{log.id}}</td>
                        <td>{{log.tlc}}</td>
                        <td>{{log.uid}}</td>
                        <td>{{log.sh}}</td>
                        <td>{{log.lt | longFormatFromDT}}</td>
                        <td>{{ProcessCategoryStatArray[log.pc]}}</td>
                        <td>{{CTStatArray[log.ct]}}</td>
                        <td>{{SVStatArray[log.sv]}}</td>
                        <td>{{log.fn}}</td>
                        <td>
                            <json-viewer
                                    :value="JsonView(log.txt)"
                                    :expand-depth = 5
                                    copyable
                                    :boxed = true
                                    :expanded = false>
                            </json-viewer>
                        </td>

                    </tr>
                    </tbody>



                </table>
            </div>
        </div>

        <br><br><br><br>
        <div class="">
            <div class="level">
                <nav class="pagination" role="navigation" aria-label="pagination">
                    <ul class="pagination-list">
                        <li v-if="pageNavigationInfo.hasFirstPageNavigation">
                            <div @click="setPage(1)" class="pagination-link">
                                <a href="#">« First</a>
                            </div>
                        </li>
                        <li v-for="index in pageNavigationInfo.pageCount" :key="index">
                            <div @click="setPage(pageNavigationInfo.start + index)" class="pagination-link">
                                <a href="#" :class="[currentPage === pageNavigationInfo.start + index ? 'current':'']" >{{ pageNavigationInfo.start + index }}</a>
                                <!--                                :class="[currentPage === pageNavigationInfo.start + index?'current':'']-->
                                <!--                                :class="{current: currentPage === pageNavigationInfo.start + index }"-->
                            </div>
                        </li>
                        <li v-if="pageNavigationInfo.hasLastPageNavigation">
                            <div @click="setPage(pageNavigationInfo.total)" class="pagination-link">
                                <a href="#">Last »</a>
                            </div>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>


        <div class="modal" id="info-modal" :class="{ 'is-active': infoModal }">
            <div class="modal-background" @click="infoModal = false"></div>
            <div class="modal-card">
                <header class="modal-card-head" style="justify-content: space-between">
                    <h1>Info Modal</h1>
                    <button class="delete" aria-label="close" @click="infoModal = false"></button>

                </header>
                <section class="modal-card-body">
                    <ul style="list-style: disc outside">
                        <li style="margin-left: 20px">
                            <p style="margin-bottom: 10px">Detailed examination of packet transfers between Device Server is provided on a daily basis.</p>
                        </li>
                        <li style="margin-left: 20px">
                            <p style="margin-bottom: 10px">By selecting the day, the package transfers of that day are displayed.</p>
                        </li>
                        <li style="margin-left: 20px">
                            <p style="margin-bottom: 10px">CT : package protocol number 101,103,105,107, 111, 201, 203, 303</p>
                        </li>
                        <li style="margin-left: 20px">
                            <p style="margin-bottom: 10px">PC : NPROC, Packet, DB, IO  → DB database process, IO file input output process, Packet transfer package process</p>
                        </li>
                        <li style="margin-left: 20px">
                            <p style="margin-bottom: 10px">FN : Filter by function name</p>
                        </li>
                        <li style="margin-left: 20px">
                            <p style="margin-bottom: 10px">SV : Debug, Info, Error, Warning → Paket transferlerinde Error, Warning, Info, Debug durumları filtrelenir.</p>
                        </li>
                        <li style="margin-left: 20px">
                            <p style="margin-bottom: 10px">Message : It is the process of searching based on the contents of transferred packages. By entering part or all of the content you want to be contained in the package contents, you may review the results.</p>
                        </li>
                    </ul>
                </section>

                <footer class="modal-card-foot">
                </footer>
            </div>
        </div>

    </div>

</template>

<script>

    import Datepicker from 'vuejs-datepicker';
    import {mapState, mapActions} from "vuex";
    import {loadingMixin} from "../../utils/mixins";
    import LoadingButton from "../../components/ui/LoadingButton";
    import Vue from 'vue';
    import JsonViewer from 'vue-json-viewer';
    Vue.use(JsonViewer);
    import 'vue-json-viewer/style.css';
    import * as moment from "moment";
    export default {
        name: "EFBOccSideLogs",
        mixins: [loadingMixin],
        components: {
            // eslint-disable-next-line vue/no-unused-components
            LoadingButton,
            Datepicker,
        },
        data()
        {
            return {
                infoModal: false,
                AdvancedSearchBarView: false,
                isActiveUserModal: false,
                selectedDayOrigin :"",
                highlighted : {dates: [new Date(this.currentDateWithFormat)]},
                WeekList : [],
                searchText : "",
                searchKFZText : "",
                isloading : false,
                searchuid :"",
                searchtlc : "",
                searchpc : "",
                searchct : "",
                searchsv : "",
                searchfn : "",
                searchtxt : "",
                searchKey: '',
                pageRange: 3,
                currentPage: 1,
                itemsPerPage: 40,
                resultCount: 0,
                pageNavigationInfo: {},
                SearchDate1 :null,
                SearchDate2 :null,
                advancedSearchTLC : false,
                advancedSearchUID : false,
                jsonExpanded : true,
                filteredOccSideLogs : [],
                advancedSearchFormTLC:{
                    uid : "",
                    tlc : "",
                    pc : "",
                    ct : "",
                    sv : "",
                    fn : "",
                    txt : ""
                },

                ProcessCategoryStatArray :[
                    "NPROC",
                    "Packet",
                    "DB",
                    "IO",
                ],

                SVStatArray :[
                    "Debug",
                    "Info",
                    "Warning",
                    "Error"
                ],

                CTStatArray :[
                  "None",
                  "101",
                  "103",
                  "105",
                  "107",
                  "111",
                  "201",
                  "203",
                  "303"
                ],

            }
        },

        async created() {
            await this.TrygetLogsfromDatepicker();
        },

        methods: {

            ...mapActions("efb",["GetWeeklyRangedListOfEFBOccSideLogs"]),

            openDateCalendar()
            {
                console.log();
                console.log("test test")
                var t = Date.now();
                console.log(t);
                this.highlighted = {dates: [new Date(t)]};
            },

            customFormatter(date) {
                return moment(date).format('YYYY-MM-DD');
            },

            setPage: function(pageNumber) {

                this.currentPage = pageNumber
                this.buildPageNavigationInfo()
            },

            setResultCount: function(count)
            {
                this.resultCount = count
            },

            setCurrentPage: function(currentPage)
            {
                this.currentPage = currentPage;
            },

            setNotifyList: function(list)
            {
                this.filteredOccSideLogs = list;
            },

            SearchFilter: function()
            {

                this.searchtlc = this.advancedSearchFormTLC.tlc
                this.searchuid = this.advancedSearchFormTLC.uid

                this.searchpc = this.ProcessCategoryStatArray.indexOf(this.advancedSearchFormTLC.pc)
                this.searchct = this.CTStatArray.indexOf(this.advancedSearchFormTLC.ct)
                this.searchsv = this.SVStatArray.indexOf(this.advancedSearchFormTLC.sv)
                this.searchfn = this.advancedSearchFormTLC.fn
                this.searchtxt = this.advancedSearchFormTLC.txt
                this.currentPage = 1;

            },


            buildPageNavigationInfo(){

                let _total = this.totalPages;
                let _current = this.currentPage;

                let firstPage = Math.max(1, _current - this.pageRange);
                let lastPage = Math.min(_total, _current + this.pageRange);
                // console.log("Pagebuild info total:" +_total+ " current:"+ _current +" firstpage:"+ firstPage + " lastpage:"+ lastPage );
                this.pageNavigationInfo = {
                    start: firstPage-1,
                    end: lastPage,
                    hasFirstPageNavigation: firstPage > 1,
                    hasLastPageNavigation: lastPage < _total,
                    pageCount: lastPage - firstPage + 1,
                    total : _total,
                }
            },

            async GetWeeklyRanged()
            {
                this.isloading = true;
                // console.log("ekran çizme loading işleminin başlatılması gerekmektedir. ")
                this.AdvancedSearchBarView = true;

                this.searchtlc =this.advancedSearchFormTLC.tlc = ""
                this.searchuid =this.advancedSearchFormTLC.uid =""
                this.searchpc = this.advancedSearchFormTLC.pc = ""
                this.searchct =this.advancedSearchFormTLC.ct = ""
                this.searchsv =this.advancedSearchFormTLC.sv = ""
                this.searchfn =this.advancedSearchFormTLC.fn = ""
                this.searchtxt =this.advancedSearchFormTLC.txt = ""
                this.currentPage = 1;



                this.filteredOccSideLogs = await this.GetWeeklyRangedListOfEFBOccSideLogs(this.selectedDayOrigin);
                this.filteredOccSideLogs = this.EFBOccSideLogs;

                this.currentPage = 1;
                this.buildPageNavigationInfo();
                // console.log("Ekran çizme işlemi tamam mı ? bütün değişimleri ile kontrol et. tam bu aşamada loading kaldıralım...");
                this.isloading = false;
            },

            async TrygetLogsfromDatepicker()
            {

                this.isloading = true;
                // console.log("ekran çizme loading işleminin başlatılması gerekmektedir. ")
                this.AdvancedSearchBarView = true;

                this.searchtlc =this.advancedSearchFormTLC.tlc = ""
                this.searchuid =this.advancedSearchFormTLC.uid =""
                this.searchpc = this.advancedSearchFormTLC.pc = ""
                this.searchct =this.advancedSearchFormTLC.ct = ""
                this.searchsv =this.advancedSearchFormTLC.sv = ""
                this.searchfn =this.advancedSearchFormTLC.fn = ""
                this.searchtxt =this.advancedSearchFormTLC.txt = ""
                this.currentPage = 1;

                var t = Date.now();

                this.highlighted = {dates: [new Date(t)]};

                this.selectedDayOrigin  = moment(t).format('YYYY-MM-DD');

                try
                {
                    this.filteredOccSideLogs = await this.GetWeeklyRangedListOfEFBOccSideLogs(this.selectedDayOrigin);
                    this.filteredOccSideLogs = this.EFBOccSideLogs;

                }
                catch(e)
                {
                    this.$notify({title: "Error", text:"Couldn't Get Data." , type: "error"});
                    this.isloading = false;
                }


                this.currentPage = 1;
                this.buildPageNavigationInfo();
                this.isloading = false;


            },



            TryAdvancedSearchTLC()
            {
                this.SearchFilter();
            },

            JsonView(value)
            {

                if(value == null || value =="")
                {
                    return "";
                }

                if (/^[\],:{}\s]*$/.test(value.replace(/\\["\\/bfnrtu]/g, '@').
                replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\\-]?\d+)?/g, ']').
                replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {

                    //the json is ok
                    var obj = JSON.parse(value);

                    if(obj == null || obj =="")
                    {
                        return "??";
                    }

                    var patt2 = /(\\")/g;

                    if(obj.toString().includes("OccSelfVersionChanges"))
                    {
                        obj.OccSelfVersionChanges=  JSON.parse(obj.OccSelfVersionChanges.toString().replace(patt2,"\"").replace(/[|]/gi,""))
                    }
                    if(obj.toString().includes("DeletedFlightInfo"))
                    {
                        obj.DeletedFlightInfo=  JSON.parse(obj.DeletedFlightInfo.toString().replace(patt2,"\"").replace(/[|]/gi,""))
                    }
                    if(obj.toString().includes("JSONTEXT"))
                    {
                        obj.JSONTEXT=  JSON.parse(obj.JSONTEXT.toString().replace(patt2,"\""))
                    }

                    return obj;
                }else{

                    return value;
                }


            },

            JsonView2(value)
            {

                if(value == null || value =="")
                {
                    return "";
                }

                if (/^[\],:{}\s]*$/.test(value.replace(/\\["\\/bfnrtu]/g, '@').
                replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\\-]?\d+)?/g, ']').
                replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {

                    //the json is ok
                    var obj = JSON.parse(value);

                    if(obj == null || obj =="")
                    {
                        return "??";
                    }

                    var patt2 = /(\\")/g;




                    if(obj.toString().includes("SubObjectName"))
                    {
                        obj.SubObjectName=  JSON.parse(obj.SubObjectName.toString().replace(patt2,"\"").replace(/[|]/gi,""))
                    }
                    if(obj.toString().includes("SubObjectName2"))
                    {
                        obj.SubObjectName2=  JSON.parse(obj.SubObjectName2.toString().replace(patt2,"\""))
                    }

                    return obj;
                }else{

                    return value;
                }


            },

            filterLogsbyTLC : function(list){
                if(!this.searchtlc || this.searchtlc == "")
                {
                    return list
                }
                else
                {
                    return list.filter(log => !log.tlc.toUpperCase().indexOf(this.searchtlc.toUpperCase().trim()));
                }

            },

            filterLogsbyUID : function(list){
                if(!this.searchuid || this.searchuid == "")
                {
                    return list
                }
                else
                {
                    return list.filter(log => !log.uid.indexOf(this.searchuid.trim()));
                }

            },

            filterLogsbyPC : function(list){

                if(!this.searchpc || this.searchpc === "" ||this.searchpc === -1)
                {
                    return list
                }
                else
                {
                    return list.filter(log => log.pc == this.searchpc);
                }
            },

            filterLogsByCT : function(list)
            {
                if(!this.searchct || this.searchct === ""|| this.searchct === -1)
                {
                    return list
                }
                else
                {
                    return list.filter(log => log.ct == this.searchct);
                }
            },

            filterLogsbySV : function(list){

                if(!this.searchsv || this.searchsv === ""|| this.searchsv === -1)
                {
                    return list
                }
                else
                {
                    return list.filter(log => log.sv == this.searchsv);
                }


            },

            filterLogsbyFN : function(list){
                if(!this.searchfn || this.searchfn == "")
                {
                    return list
                }
                else
                {
                    return list.filter(log => !log.fn.toString().toUpperCase().indexOf(this.searchfn.trim().toUpperCase()));
                }

            },


            filterLogsbyTXT : function(list){
                if(!this.searchtxt || this.searchtxt == "")
                {
                    return list
                }
                else
                {
                    return list.filter(log => JSON.stringify(log.txt).toUpperCase().match(this.searchtxt.trim().toUpperCase()));
                }

            },

        },

        computed : {

            ...mapState("efb",["EFBOccSideLogs"]),

            totalPages: function() {
                return Math.ceil(this.resultCount / this.itemsPerPage)
            },



            paginate2 : function()
            {

                // 1. adım listeyi al

                if (!this.EFBOccSideLogs || this.EFBOccSideLogs.length != this.EFBOccSideLogs.length)
                {
                    return
                }

                this.setNotifyList(this.EFBOccSideLogs);

                // 2. adım filtre et.

                var list = this.filterLogsbyTLC(this.filterLogsbyUID(this.filterLogsbyPC(this.filterLogsByCT(this.filterLogsbySV(this.filterLogsbyFN(this.filterLogsbyTXT(this.EFBOccSideLogs)))))))
                // console.log("list length is : "+list.length);

                this.setResultCount(list.length);

                if (this.currentPage >= this.totalPages)
                {
                    this.setCurrentPage(this.totalPages);
                }

                var index = this.currentPage * this.itemsPerPage - this.itemsPerPage

                this.buildPageNavigationInfo();

                return list.slice(index, index + this.itemsPerPage)

                // 3. adım pagin hesaplamalarını onun üerinde döndür.
            },


        }
    }
</script>

<style scoped lang="scss">

    .pagination {
        display: inline-block;
    }

    .pagination a {
        color: black;
        float: left;
        padding: 8px 16px;
        text-decoration: none;
        transition: background-color .3s;
    }

    .pagination a.active {
        background-color: #4CAF50;
        color: white;
    }

    .pagination a:hover:not(.active) {background-color: #ddd;}

    a {
        color: #999;
    }
    .current {
        color: red;
    }
    ul {
        padding: 0;
        list-style-type: none;
    }
    li {
        display: inline;
        margin: 5px 5px;
    }

    a.first::after {
        content:'...'
    }

    a.last::before {
        content:'...'
    }

    .progressfix{
        margin-bottom: 3px !important;
    }

    .fontsizesmall{
        font-size: 12px;
    }

    .user-table thead th {
        color: white;
        background-color: #6a85a7;
        font-style: normal;
        font-size: 17px;
        top: -12px;
        position: sticky;
        z-index: 2;
    }

    .create-button {
        background-color: #6a85a7;
        color: white;
        font-size: 10px;
        font-size: 1.1rem;
        min-height: auto;
    }

    .user-table td {
        border: 0px;
    }

    .user-table {
        overflow-y: scroll;
        height: 790px;
    }

    .user-table th {
        top: -12px;
        position: sticky;
        background-color: white;
        z-index: 2;
    }

    .user-menu {
        background-color: #fff;
        /*border-radius: 6px;*/
        box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .02);
        color: #4a4a4a;
        display: block;
        padding: 1.25rem;
        margin-bottom: 5px;
        margin-top: 5px;
    }

    .role-selected {
        border: 0;
        cursor: pointer;
        font-size: 1em;
        font-family: Arial;
        position: relative;
    }

    .role-selected option {
        background-color: #6a85a7;
        color: white;
        font-family: sans-serif;
        font-style: unset;
        top: 100%;
        left: 0;
        right: 0;
        z-index: 99;
        position: absolute;
    }

    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar {
        height: 2px;
        width: 8px;
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #6a85a7;
    }

    .tooltip .tooltiptext {
        visibility: hidden;
        min-width: 400px;
        max-width: 420px;
        background-color: #6a85a7de;
        border:3px solid;
        border-color: #4f4f4f;
        color: #fff;
        border-radius: 6px;
        top: 100%;
        left: 50%;
        margin-left: -366px;
        padding: 10px;
        margin-right: 23px;
        margin-top: 13px;
        font-size: 15px;
        text-align: left;

        /* Position the tooltip */
        position: absolute;
        z-index: 1111;
    }

    .tooltip:hover .tooltiptext {
        visibility: visible;
    }


</style>


